// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2g-hD","list":"BalanceDue_list__1zjYO","listRow":"BalanceDue_listRow__1jMqn","total":"BalanceDue_total__3W5H5"};